module.exports = __webpack_public_path__ + "915db8f68ba1dcbf017286210a701ea6.fbx";